import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg48EmptyPosition = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/jsx("rect", {
      width: 46,
      height: 20,
      x: 1,
      y: 14,
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      rx: 1
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg48EmptyPosition$1 = Svg48EmptyPosition;

export { Svg48EmptyPosition$1 as default };
